import React from "react";
import { Button, styled, Typography } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { WHATSAPP_PHONE } from "../../utils/contact";
import { ButtonWrapper } from "../shared/StyledComponents";

const WhatsAppButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.brand.whatsapp,
  color: theme.palette.common.white,
  textTransform: "none",
  "&:hover": {
    backgroundColor: theme.palette.brand.whatsappHover,
  },
}));

const ProcessOrderButton: React.FC = () => {
  const handleClick = () => {
    const currentUrl = window.location.href;
    const message = `Hola orientador biai, ayúdame a procesar el pedido ${currentUrl}`;
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${WHATSAPP_PHONE}&text=${encodeURIComponent(
      message,
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <ButtonWrapper>
      <WhatsAppButton onClick={handleClick} variant="contained">
        <Typography paddingRight={1} fontWeight="bold">
          Procesar pedido con asesor
        </Typography>
        <WhatsAppIcon />
      </WhatsAppButton>
    </ButtonWrapper>
  );
};

export default ProcessOrderButton;
